import { Box, Button, Container, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tabs, Typography } from "@mui/material"
import ReporteService from "../../services/Reporte"
import { useEffect, useState } from "react";
import { reporteDataDTO, ReporteDTO, reportePostulante, VoidReporteDTO } from "../../interfaces/AYUDANTIAS/Reporte";
import AcademicoService from "../../services/AcademicoService";
import { PeriodoAcademico, VoidPeriodoAcademico } from "../../interfaces/SAAC/PeriodoAcademico";
import { useAppSelector } from "../../redux/hooks";
import { useIsAuthenticated } from "@azure/msal-react";
import { PantallaCargaPage } from "../../pages/Modulos/PantallaCargaPage";
import { useFormik } from "formik"
import { MdSave } from "react-icons/md";
import { RiFileExcel2Line } from "react-icons/ri";
import { FaRegFilePdf } from "react-icons/fa";
import AlertService from "../../services/AlertService";

const reporteService = new ReporteService()
const academicoService = new AcademicoService()
const alertService = new AlertService()

const rowsPerPage = [5, 10, 25, 100];
export const ReporteAyudantiaInv: React.FC<{}> = () => {
    
    const [reporteData, setReporteData] = useState<Array<reporteDataDTO>>([]);
    const [postuladosData, setPostuladosData] = useState<Array<reportePostulante>>([]);

    const [periodoActivo, setPeriodoActivo] = useState<PeriodoAcademico>(VoidPeriodoAcademico());
    const[readyReporte, setReadyReporte] = useState<boolean>(false);
    const [tipoBtnPresionado, setTipoBtnPresionado] = useState("");
    const [globalFilter, setGlobalFilter] = useState('T');
    const [page, setPage] = useState(0);
    const [rowsperpage, setRowsPerPage] = useState(rowsPerPage[0]);
    const [tabIndex, setTabIndex] = useState(0);
    const[readyPostulados, setReadyPostulados] = useState<boolean>(false);

    const [page2, setPage2] = useState(0);
    const [rowsperpage2, setRowsPerPage2] = useState(rowsPerPage[0]);
    

    const isAuthenticated = useIsAuthenticated();
    //const isAuthenticated = useMockIsAuthenticated();
    const token = useAppSelector((state) => state.authReducer.token);
    const { userData } = useAppSelector((state) => state.authReducer);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
    };

    const GetReporteInvestigacionData = async (idPeriodo : number) => {
        try{
          await reporteService.GetReporteAyudantiasDeInvestigacionData(token,idPeriodo)
          .then((data)=>{
            if(data.status.isSuccessfully){
              setReporteData(data.listData)
              setReadyReporte(true);
            }else{
              setReporteData([])
              setReadyReporte(true);
            }
          })
        }
        catch(error){
          console.error('Error:', error);
        }
    }

    const GetReportePostuladosData = async (idPeriodo : number) => {
        try{
          await reporteService.GetReporteEstudiantesPostuladosData(token,idPeriodo)
          .then((data)=>{
            if(data.status.isSuccessfully){
                setPostuladosData(data.listData)
                setReadyPostulados(true);
            }else{
                setPostuladosData([])
                setReadyPostulados(true);
            }
          })
        }
        catch(error){
          console.error('Error:', error);
        }
    }

    const GetPeriodo = async () => {
        try {
            const response = await academicoService.GetPeriodoAcademicoEnEjecucion(token);
            setPeriodoActivo(response.data);
            return response.data; // Retorna el periodo
        } catch (error) {
            console.error(error);
            return VoidPeriodoAcademico(); // Manejo de errores
        }
    };

    const formik = useFormik({
        initialValues :{
            estado :  'T',
        },
        enableReinitialize: true,
        //validationSchema : tipobtn =="A" ?  AccionHorasValidate : AccionSolicitudAyudantiaValidate,
        onSubmit: async (values) =>{
            await descargarInformePorTipo(token,periodoActivo.idperiodo,userData.netId,values.estado,tipoBtnPresionado);
        }
    });

    const reporteFiltro = reporteData.filter((reporte) => {
        if (globalFilter === "T") return true; // Mostrar todos
      
        if (globalFilter === "A") return reporte.estadoSubdecano === "APROBADO";
        if (globalFilter === "N") return reporte.estadoSubdecano === "NEGADO";
      
        return false; // Por si acaso llega un valor inesperado
    });

    const descargarInformePorTipo = async(token: any, idPeriodo: number, usuario: string, estado: string, tipoDoc: string) =>{
        alertService.showLoading("Generando reporte");
        await reporteService.GetReporteAyudantiasDeInvestigacionArchivos(token, idPeriodo,usuario, estado, tipoDoc)
        .then((response) =>{
            if(response.status.isSuccessfully){
                //setArchivoData(response.data)
                descargarArchivoDesdeBase64(response.data.nombreArchivo, response.data.archivobase64, tipoDoc);
                alertService.hideLoading();

            }else{
                alertService.alertaAdvertencia("Archivo no generado","Ocurrió un error al generar el archivo, por favor intente más tarde");
            }
        })
    }

    const descargarInformePostulantesPorTipo = async(token: any, idPeriodo: number, usuario: string,tipoDoc: string) =>{
        alertService.showLoading("Generando reporte");
                await reporteService.GetReporteEstudiantesPostuladosArchivo(token, idPeriodo,usuario,tipoDoc)
                .then((response) =>{
                    if(response.status.isSuccessfully){
                        //setArchivoData(response.data)
                        descargarArchivoDesdeBase64(response.data.nombreArchivo, response.data.archivobase64, tipoDoc);
                        alertService.hideLoading();

                    }else{
                        alertService.alertaAdvertencia("Archivo no generado","Ocurrió un error al generar el archivo, por favor intente más tarde");
                    }
                })
    }

    function descargarArchivoDesdeBase64(nombreArchivo: string, base64: string, tipoArchivo: string) {
        // Determinar MIME type y extensión
        let mimeType = "";
        let extension = "";
      
        switch (tipoArchivo.toLowerCase()) {
          case "e":
            mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            extension = ".xlsx";
            break;
          case "p":
            mimeType = "application/pdf";
            extension = ".pdf";
            break;
          default:
            console.error("Tipo de archivo no soportado");
            return;
        }
      
        // Asegurar que el nombre tenga la extensión correcta
        if (!nombreArchivo.toLowerCase().endsWith(extension)) {
          nombreArchivo += extension;
        }
      
        // Convertir base64 a Blob
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });
      
        // Crear y activar el enlace de descarga
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = nombreArchivo;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleChangePage2 = (event: unknown, newPage: number) => {
        setPage2(newPage);
    };
    const handleChangeRowsPerPage2 = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage2(+event.target.value);
        setPage2(0);
    };
    
    useEffect(()=>{
        if (isAuthenticated ) {
            GetPeriodo().then((response)=>{
                if(response){
                    GetReporteInvestigacionData(response.idperiodo);
                    GetReportePostuladosData(response.idperiodo);
                }
            })
            
        }
    },[token,isAuthenticated])

    return(
        <Container maxWidth="lg" sx={{ padding: "20px", width:'95%' }}>
            <Tabs
                value={tabIndex}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                centered
                sx={{ marginY: 3 }}
            >
                <Tab sx={{ fontWeight: "bold", color: "#243165", marginBottom: "10px", fontSize: "16px" }} label="Reporte ayudantías de investigación" />
                <Tab sx={{ fontWeight: "bold", color: "#243165", marginBottom: "10px", fontSize: "16px" }} label="Reporte de postulantes" />
            </Tabs>

            {
                tabIndex == 0 && (
                    <Container maxWidth="lg" sx={{padding:"10px", }}>
                        <form onSubmit={formik.handleSubmit} style={{marginBottom:"20px"}}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={1} md={3} lg={6}>
                                    <FormControl fullWidth>
                                    <InputLabel htmlFor="select-estado">Estado</InputLabel>
                                    <Select
                                        labelId="select-estado"
                                        name="estado"
                                        label="Estado"
                                        variant="outlined"
                                        value={formik.values.estado}
                                        onChange={(event) => {
                                            formik.setFieldValue("estado", event.target.value);
                                            setGlobalFilter(event.target.value);
                                        }}
                                        onBlur={formik.handleBlur}
                                    >
                                        <MenuItem value={'T'}>Todas</MenuItem>
                                        <MenuItem value={'A'}>Aprobadas</MenuItem>
                                        <MenuItem value={'N'}>Negadas</MenuItem>
                                    </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item>
                                    <Button
                                    sx={{
                                        backgroundColor: "#217346",
                                        color: "#FFFFFF !important",
                                        "&:hover": { backgroundColor: "#1a5c37" },
                                        boxShadow: 3,
                                    }}
                                    type="submit"
                                    variant="contained"
                                    endIcon={<RiFileExcel2Line />}
                                    onClick={() => setTipoBtnPresionado("E")}
                                    >
                                    Descargar Excel
                                    </Button>
                                </Grid>

                                <Grid item>
                                    <Button
                                    sx={{
                                        backgroundColor: "#D32F2F",
                                        color: "#FFFFFF !important",
                                        "&:hover": { backgroundColor: "#B71C1C" },
                                        boxShadow: 3,
                                    }}
                                    type="submit"
                                    variant="contained"
                                    endIcon={<FaRegFilePdf />}
                                    onClick={() => setTipoBtnPresionado("P")}
                                    >
                                    Descargar PDF
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>

                        

                        <Paper  elevation={3} sx={{ padding: 2, marginBottom: 3}}>
                            {
                                readyReporte ? 
                                <TableContainer component={Paper} elevation={2}>
                                    <Table>
                                        <TableHead>
                                            <TableRow sx={{ backgroundColor: "#243165"}}>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>N° de la solicitud</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Periodo Académico</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold", minWidth: 200 }}>Código de Proyecto</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold", minWidth: 300 }}>Nombre del Proyecto</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold", minWidth: 300 }}>Nombre del Director</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Correo del Director</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold", minWidth: 350 }}>Nombre del Tutor</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Correo del Tutor</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold", minWidth: 250  }}>Matrícula del Estudiante</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold", minWidth: 350 }}>Nombre del Estudiante</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Correo del Estudiante</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold", minWidth: 400 }}>Unidad del Estudiante</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold", minWidth: 250 }}>Carrera del Estudiante</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold", minWidth: 850 }}>Actividades del Estudiante</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold", minWidth: 250 }}>Fecha de Ingreso de la Solicitud</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold", minWidth: 250 }}>Hora de Ingreso de la Solicitud</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Horas Solicitadas</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Financimiento del ayudante</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold", minWidth: 250 }}>Estado de la Solicitud por parte de Decanato</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold", minWidth: 250}}>Estado de la Solicitud por parte de Vicerrectorado</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Horas Otorgadas</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold" , minWidth: 300}}>Motivo</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                reporteFiltro.slice(page * rowsperpage, page * rowsperpage + rowsperpage).map((reporte, index)=>(
                                                    <TableRow key={index}>
                                                        <TableCell align="center">{index+1}</TableCell>
                                                        <TableCell align="center">{reporte.termino}</TableCell>
                                                        <TableCell align="center">{reporte.codigoProyecto}</TableCell>
                                                        <TableCell align="justify">{reporte.nombreProyecto}</TableCell>
                                                        <TableCell align="center">{reporte.nombreDirector}</TableCell>
                                                        <TableCell align="center">{reporte.correoDirector}</TableCell>
                                                        <TableCell align="center">{reporte.nombreInvestigador}</TableCell>
                                                        <TableCell align="center">{reporte.emailResponsable}</TableCell>
                                                        <TableCell align="center">{reporte.codestudiante}</TableCell>
                                                        <TableCell align="center">{reporte.nombreEstudiante}</TableCell>
                                                        <TableCell align="center">{reporte.correoEstudiante}</TableCell>
                                                        <TableCell align="center">{reporte.unidadEstudiante}</TableCell>
                                                        <TableCell align="center">{reporte.carreraEstudiante}</TableCell>
                                                        <TableCell align="justify">{reporte.actividades}</TableCell>
                                                        <TableCell align="center">{reporte.fechasolicitud}</TableCell>
                                                        <TableCell align="center">{reporte.horaIngresoSolicitud}</TableCell>
                                                        <TableCell align="center">{reporte.horas}</TableCell>
                                                        <TableCell align="center">{reporte.financiamientoTexto}</TableCell>
                                                        <TableCell align="center">{reporte.estadoSubdecano}</TableCell>
                                                        <TableCell align="center">{reporte.estadoVicerrectorado}</TableCell>
                                                        <TableCell align="center">{reporte.horasOtorgadas}</TableCell>
                                                        <TableCell align="center">{reporte.comentario}</TableCell>
                                                    </TableRow>
                                                    
                                                ))
                                            }

                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                            rowsPerPageOptions={rowsPerPage}
                                            component="div"
                                            count={reporteFiltro.length}
                                            rowsPerPage={rowsperpage}
                                            page={page}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                        />
                                </TableContainer>
                                :
                                <PantallaCargaPage/>
                            }
                    

                        </Paper>

                    </Container>

                )
            }
            {
                tabIndex == 1 && (
                    <Container maxWidth="lg" sx={{padding:"10px"}}>
                        <Grid container spacing={2} alignItems="center" justifyContent="center" paddingBottom={"10px"}>
                            <Grid item>
                                <Button
                                sx={{
                                    backgroundColor: "#217346",
                                    color: "#FFFFFF !important",
                                    "&:hover": { backgroundColor: "#1a5c37" },
                                    boxShadow: 3,
                                }}
                                type="submit"
                                variant="contained"
                                endIcon={<RiFileExcel2Line />}
                                onClick={() => descargarInformePostulantesPorTipo(token,periodoActivo.idperiodo,userData.netId,"E")}
                                >
                                Descargar Excel
                                </Button>
                            </Grid>

                            <Grid item>
                                <Button
                                sx={{
                                    backgroundColor: "#D32F2F",
                                    color: "#FFFFFF !important",
                                    "&:hover": { backgroundColor: "#B71C1C" },
                                    boxShadow: 3,
                                }}
                                type="submit"
                                variant="contained"
                                endIcon={<FaRegFilePdf />}
                                onClick={() => descargarInformePostulantesPorTipo(token,periodoActivo.idperiodo,userData.netId,"P")}
                                >
                                Descargar PDF
                                </Button>
                            </Grid>

                        </Grid>

                        <Paper  elevation={3} sx={{ padding: 2, marginBottom: 3}}>
                            {
                                readyPostulados ? 
                                <TableContainer component={Paper} elevation={2}>
                                    <Table>
                                        <TableHead>
                                            <TableRow sx={{ backgroundColor: "#243165"}}>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold", minWidth: 400  }}>Nombre del estudiante</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold",  minWidth: 100 }}>Matrícula</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold", minWidth: 100 }}>Carrera</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold", minWidth: 400 }}>Unidad</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold", minWidth: 200 }}>Correo del estudiante</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Deudas</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Regularidad</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Promedio</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold",}}>MOOC</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold",}}>Sanciones</TableCell>
                                                <TableCell align="center" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Materias reprobadas</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                postuladosData.slice(page2 * rowsperpage2, page2 * rowsperpage2 + rowsperpage2).map((reporte, index)=>(
                                                    <TableRow key={index}>
                                                        <TableCell align="center">{reporte.nombreEstudiante}</TableCell>
                                                        <TableCell align="center">{reporte.matricula}</TableCell>
                                                        <TableCell align="center">{reporte.carreraEstudiante}</TableCell>
                                                        <TableCell align="center">{reporte.unidadEstudiante}</TableCell>
                                                        <TableCell align="center">{reporte.correoEstudiante}</TableCell>
                                                        <TableCell align="center">{reporte.tieneDeudas}</TableCell>
                                                        <TableCell align="center">{reporte.esRegular}</TableCell>
                                                        <TableCell align="center">{reporte.promedio.toFixed(2)}</TableCell>
                                                        <TableCell align="center">{reporte.hizoMOOC}</TableCell>
                                                        <TableCell align="center">{reporte.tieneSanciones}</TableCell>
                                                        <TableCell align="center">{reporte.materiasReprobadas}</TableCell>
                                                    </TableRow>
                                                    
                                                ))
                                            }

                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                            rowsPerPageOptions={rowsPerPage}
                                            component="div"
                                            count={postuladosData.length}
                                            rowsPerPage={rowsperpage2}
                                            page={page2}
                                            onPageChange={handleChangePage2}
                                            onRowsPerPageChange={handleChangeRowsPerPage2}
                                        />
                                </TableContainer>
                                :
                                <PantallaCargaPage/>
                            }
                        </Paper>
                    </Container>
                )
            }



            {/* <Typography
                variant="h4"
                align="center"
                gutterBottom
                sx={{ fontWeight: "bold", color: "#243165", marginBottom: "20px", fontSize: "16px" }}
            >
                REPORTE AYUDANTIAS DE INVESTIGACIÓN
            </Typography> */}
            {/* <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
                <Box
                sx={{
                    height: 4,
                    width: "100px",
                    bgcolor: "primary.main",
                    borderRadius: "2px",
                }}
                />
            </Box> */}
            




        </Container>
    )
}